import GET_ARTICLES from "../plugins/getArticles";

// import 'slick-carousel'
export default function HOME() {
  const w = window

  const newsBlockInit = () => GET_ARTICLES('.p-top-news',{
    makeItem(item,opt){
      const $item = $(`
        <a href="${item.href}" class="p-top-news__card">
          <div class="p-top-news__card-img">
            <div class="p-top-news__card-img__inner" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" /></div>
          </div>
          <div class="p-top-news__card-body">
            <p class="p-top-news__card-date">${item.date}</p>
            <h4 class="p-top-news__card-title">${item.title}</h4>
            <p class="p-top-news__card-desc">${item.desc}</p>
          </div>
        </a>
      `)
      const $catlink = $(`<a href="${item.category.href}" class="${opt.prefix}card-category is-cat${item.category.id}">${item.category.name}</a>`)
      $item.prepend( $catlink )
      return $item[0]
    }
  })

  $(() => {
  
    // トップページカスタム
    $.topInit();

    w.load['top-news'].done(newsBlockInit)
  
  })

}